<template>
  <div>
    <SettingsNavigation />

    <BaseWrapper>
      <CandidateUsageCard v-if="isPerCandidate" />
      <PAYGUsageCard v-else />
    </BaseWrapper>
  </div>
</template>

<script>
import SettingsNavigation from '@components/Settings/SettingsNavigation'
import CandidateUsageCard from '@components/Settings/CandidateUsageCard'
import PAYGUsageCard from '@components/Settings/PAYGUsageCard'

import { mapGetters } from 'vuex'

export default {
  components: {
    SettingsNavigation,
    CandidateUsageCard,
    PAYGUsageCard
  },

  computed: {
    ...mapGetters({
      isPerCandidate: 'organisations/isPerCandidate'
    })
  }
}
</script>
